const styleguide4i = function() {
	const forms = new forms4i();
	const mainContent = document.getElementById("mainContent");
	const styleForm = document.getElementById("styleGuideForm");
	const tabArea = document.getElementById("copyTabs");
	const toolTip = document.getElementsByClassName("tooltipWrapper")[0];
	const accordionHeader = document.getElementsByClassName("accordionHeader")[0];
	let cardNumber, saveCCBtn;
	
	const init = () => {
		if (accordionHeader) initAccordions();
		if (tabArea) initTabs();
		if (toolTip) initTooltips();
		if(styleForm) initForm();

		document.addEventListener("click", styleEvents);
	};
	
	const styleEvents = e => {
		const el = e.target;
		let copyText;
		if(e.target.classList.contains("copyCode") || e.target.parentNode.classList.contains("copyCode")){
			e.preventDefault();
			if(e.target.classList.contains("copyCode")) copyText = el.parentNode.nextElementSibling.textContent;
			else if(e.target.parentNode.classList.contains("copyCode")) copyText = el.parentNode.parentNode.nextElementSibling.textContent;
			navigator.clipboard.writeText(copyText);
		}else if(e.target.classList.contains("copyJSCode") || e.target.parentNode.classList.contains("copyJSCode")){
			e.preventDefault();
			if(e.target.classList.contains("copyJSCode")) copyText = el.previousElementSibling.textContent;
			else if(e.target.parentNode.classList.contains("copyJSCode")) copyText = el.parentNode.previousElementSibling.textContent;
			navigator.clipboard.writeText(copyText);
		}else if(e.target.classList.contains("repeatAnimation")){
			e.preventDefault();
			repeatAnimation(el);
		}
	};
	
	const initSnackBar = () => {
		// TESTING
	    	/*const snackBar = new Snackbar4i();
	    	const callBack = () => {
	    		console.log("it worked");
	    	};
	    	setTimeout(() => { 
	    		snackBar.Create("Oops! Your form failed to submit.", 6000);
			snackBar.SetAction("Retry", callBack); //optional, not needed
			snackBar.Show();
	    	}, 1000);*/
	};
	
	const initAccordions = () => {
		const accordionsStyle = new getAccordions4i();
    		accordionsStyle.init(mainContent);
	};
	
	const initTabs = () => {
		const tabs = new tabs4i();
    		tabs.init(tabArea);
	};
	
	const initTooltips = () => {
		const tooltips = new toolTips();
    		tooltips.init();
	};
	
	const initForm = () => {
		const formSubmitBtn = document.getElementById("btnSubmit");
		cardNumber = document.getElementById('CardNumber');
		saveCCBtn = document.getElementById('btnSaveCreditCard');
		
		formSubmitBtn.addEventListener("click", validateForm);
    		if(cardNumber) cardNumber.addEventListener('keyup', fadeCC);
	};
	
	const fadeCC = () => {
		forms.FadeCCImgs(cardNumber, saveCCBtn, null);
	};
	
	const validateForm = (e) => {
		e.preventDefault();
		forms.formValidation(styleForm, formValidationSuccess, e);
	};
	
	const formValidationSuccess = () => {
		styleForm.insertAdjacentHTML('beforebegin', '<p class="text18 textSemiBold textDarkestGray"><svg class="textDarkestGray roundCorners5 bkgdGreen inlineMiddle" height="30px" width="30px"><use xlink:href="#svgIcon-checkMark"></use></svg> <span class="inlineMiddle marginLeft5">Your form submitted successfully!</span></p>');
    		styleForm.classList.add("hide");
	};

	const repeatAnimation = (el) => {
		const animatedElement = el.parentNode.nextElementSibling;
		animatedElement.classList.add("hide");
		setTimeout(() => { animatedElement.classList.remove("hide"); }, 100);
	};
		
	return{
		Init: init
	};
};

(async () =>{
	const styleguide = new styleguide4i();
	styleguide.Init();
})();